import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_FAVORITED_PRODUCTS } from 'mocks/queries';

const useFavoriteCount = () => {
  const { data: favoriteProducts } = useSuspenseQuery(GET_FAVORITED_PRODUCTS);
  const favoriteCount = favoriteProducts?.products?.length ?? 0;

  return favoriteCount;
};

export default useFavoriteCount;
